<template>
  <div class="index">
    <div class="model">
      <div class="body">
        <p class="title"></p>
        <p class="content"></p>
        <p class="btns" style="display:none">
          <span class="cancel">取消</span>
          <span class="confirm">确定</span>
        </p>
        <p class="foot"></p>
      </div>
    </div>
    <div class="loading" id="loading" v-show="loading">
      <div class="circle"></div>
    </div>
    <div class="main" id="voucherPage" style="margin-top:0;">
      <div class="title">
        <p class="zhongan">WiFi安全险</p>
        <div class="already" v-if="obj.state == 0">已参保</div>
        <div class="already" v-if="obj.state == 1" style="color:#0285F0">处理中</div>
        <div class="already" v-if="obj.state == 2" style="color:#0285F0">审核中</div>
        <div class="already" v-if="obj.state == 3" style="color:#0285F0">审核失败</div>
        <!-- <p class="status" v-if="obj.state == 0"></p>
        <p class="status" v-if="obj.state == 1"></p> -->
        <div class="logo"></div>
        <div class="al-item" style="margin-top:16px">
          <div class="left">累计最高赔付人民币</div>
          <div class="right">￥{{obj.allMax}}元</div>
        </div>
        <div class="al-item">
          <div class="left">单日/单次最高赔付人民币</div>
          <div class="right">￥{{obj.oneMax}}元</div>
        </div>
        <div class="al-item">
          <div class="left">保障期限</div>
          <div class="right">{{obj.startDate}}至{{obj.endDate}}</div>
        </div>
        <div class="al-item">
          <div class="left">支付金额</div>
          <div class="right">￥{{obj.pay}}元</div>
        </div>
        <div class="al-item">
          <div class="left">保险详细</div>
          <a class="right a" @click="clickRange">保障范围</a>
        </div>
        <div class="al-item" style="padding-bottom:24px">
          <div class="left">服务热线</div>
          <a class="right a" @click="range" :href="`tel:${obj.hotLine}`">{{obj.hotLine}}</a>
        </div>
      </div>
      <qa :type="5"></qa>
      <div class="logo-image"></div>
      <div class="copyright">南京尚网网络科技有限公司对以上信息保留最终解释权</div>
      <div style="position:fixed;bottom:0;width:100%;margin-top:15px; display: flex">
        <div
          class="bottom_btn halfwidth"
          id="btn_claim"
          @click="goClaim"
        >我要索赔</div>
        <router-link
          class="bottom_btn claimList halfwidth"
          to="/new/claimList"
          v-if="isClaim"
          style="display:inline-block"
        >
          <div @click="clickClaimList">索赔记录</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import qa from "@/components/qa";
import { getInsuranceInfo, commitClamList} from "../services/common/index";
const AES = require("@/lib/Utils/AES").default;
export default {
  name: "newinsureDetail",
  components: {
    qa,
  },

  data() {
    return {
      msg: "tests",
      obj: {},
      appinfo: "",
      createBtn: 1,
      pageStatus: 0,
      loading: false,
      isClaim: false,
      appid: this.$route.query.appid,
    };
  },

  mounted () {
    // 查询保单
    getInsuranceInfo({})
      .then((res) => {
        const { data = {} } = res
        this.obj = data;
        console.log(`ssss`, res);
      })
      .catch((err) => {
        const { retCd, msg } = err;
        if (retCd === "-1") {
          this.$toast(msg);
        }
        console.log(`err`, retCd, msg);
      });

      // 查看是否投保
      commitClamList()
      .then((res) => {
        const { data , retCd, msg} = res
        if (retCd === '0' && data && data.length > 0) {
          this.isClaim = true
        }
        console.log(`commitClamList`, commitClamList);
      })
      .catch((err) => {
        const { data , retCd, msg} = err
      });
  },
  methods: {
    clickRange() {
      this.$trace.trace("ins_mine_detail", 'sup');
      this.$router.push({path: '/new/range'})
      console.log(`点保障范围`);
    },
    range() {

    },
    clickClaimList() {
      this.$trace.trace("ins_mine_record", 'sup');
      console.log(`点索赔记录`);
    },

    goClaim () {
      this.$trace.trace("ins_mine_claim", 'sup');
      console.log(`我要索赔`, this.obj.status);
      if (this.obj.state == 1) {
        safe.model({
          title: "温馨提示",
          content: "您有一笔保单正在索赔中，不能提交新的索赔",
          foot: "我知道了",
        });
        safe.bindModelEvent();
        return;
      } else {
        this.$router.push("/new/claimStep1");
      }
    },
  },
};
</script>

<style scoped>
.halfwidth {
  /* width: 50% !important; */
  flex: 1;
}
.main {
  width: 100%;
  overflow-x: hidden;
  margin: 0 auto;
}
.banner {
  padding: 4% 4.8%;
  margin-bottom: 11px;
  background: #fff;
}

.button-fixed {
  width: 100%;
  line-height: 50px;
  font-size: 18px;
  text-align: center;
  position: fixed;
  bottom: 0px;
  display: flex;
}
.button-item {
  width: 100%;
  line-height: inherit;
  text-align: center;
  background-image: linear-gradient(-90deg, #42a9fd 0%, #0285f0 99%);
  color: #ffffff;
}

.banner p {
  padding: 0;
  color: #787878;
  font-size: 13px;
  line-height: 21px;
}
.protect {
  position: relative;
  text-align: center;
}
.protect p {
  font-size: 16px;
  line-height: 60px;
  color: #000;
  font-weight: 600;
}
.protect .line {
  position: absolute;
  top: 29px;
  width: 34.66%;
  height: 1px;
  background: #e8e8e8;
}
.protect .left {
  left: -1%;
}
.protect .right {
  right: -1%;
}
.detail-item {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
}
.detail-item .left {
  float: left;
  color: #626262;
  vertical-align: middle;
  height: 32px;
  font-weight: 300;
}
.detail-item .right {
  float: right;
  color: #151515;
  vertical-align: middle;
  height: 32px;
}
.detail-item .big {
  float: none;
  font-size: 22px;
  color: #3474b8;
  margin: 0 3px;
}
.detail .btn {
  color: #0285f0;
  font-size: 14px;
  line-height: 60px;
}
.detail .left-panel,
.detail .right-panel {
  position: relative;
  display: inline-block;
  width: 49%;
  padding: 0;
  margin: 0;
  padding-bottom: 43px;
}
.detail .right-panel {
}
.detail .icon {
  width: 100%;
  padding-top: 28%;
  margin-top: 26px;
  margin-bottom: 17px;
}
.icon1 {
  background: url(../images/index/icon1.png) no-repeat center;
  background-size: contain;
}
.icon2 {
  background: url(../images/index/icon2.png) no-repeat center;
  background-size: contain;
}
.detail .left-panel p,
.detail .right-panel p {
  padding: 0;
  margin: 0;
  color: #3f3f3f;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
}
.logo-image {
  margin-top: 30px;
  width: 100%;
  padding-top: 2.9%;
  background: url(../images/index/logo-image.png) no-repeat center;
  background-size: contain;
}
.copyright {
  font-size: 12px;
  line-height: 26px;
  color: #e0e0e0;
  text-align: center;
  font-weight: 300;
  padding-bottom: 60px;
}
.title .already {
  font-size: 14px;
  line-height: 26px;
  color: #666666;
  font-weight: 400;
  padding-bottom: 14px;
  border-bottom: 1px solid #e8e8e8;
}
.al-item {
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  font-weight: 400;
}
.al-item .left {
  float: left;
}
.al-item .right {
  float: right;
}
.al-item .a {
  display: block;
  text-decoration: underline;
  color: #0285f0;
}

.title .logo {
  position: absolute;
  right: 6%;
  top: 5px;
  width: 85px;
  height: 85px;
  background-image: url(../images/index/baozhang.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// insureDetail.vue?311dd4ff